import React from 'react';
import styled from 'styled-components';
import { IconButton } from './Button';
import VipIcon from '../Icons/VipIcons';
import { Button, SecondaryButton } from './index';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  min-width: 320px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  max-height: 80vh;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
`;

const FilterSection = styled.div`
  margin-bottom: 20px;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const FilterSectionTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
`;

const FilterOption = styled.label`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const RadioInput = styled.input`
  margin-right: 12px;
  accent-color: ${({ theme }) => theme.colors.primary};
`;

const OptionLabel = styled.span`
  font-size: 14px;
  color: #495057;
  flex: 1;
`;

const OptionDescription = styled.span`
  font-size: 12px;
  color: #6c757d;
  margin-left: 8px;
`;

const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
`;

const FilterModal = ({ 
  isOpen, 
  onClose, 
  title = "Filter & Sort",
  sections = [],
  onApply,
  onReset
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleApply = () => {
    if (onApply) {
      onApply();
    }
    onClose();
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <IconButton $size="small" aria-label="Close" onClick={onClose}>
            <VipIcon name="X" size={20} />
          </IconButton>
        </ModalHeader>
        
        {sections.map((section, sectionIndex) => (
          <FilterSection key={sectionIndex}>
            <FilterSectionTitle>{section.title}</FilterSectionTitle>
            {section.options.map((option, optionIndex) => (
              <FilterOption key={optionIndex}>
                <RadioInput
                  type="radio"
                  name={section.name}
                  value={option.value}
                  checked={option.checked}
                  onChange={option.onChange}
                />
                <OptionLabel>{option.label}</OptionLabel>
                {option.description && (
                  <OptionDescription>{option.description}</OptionDescription>
                )}
              </FilterOption>
            ))}
          </FilterSection>
        ))}
        
        <ModalActions>
          {onReset && (
            <SecondaryButton onClick={handleReset}>
              Reset
            </SecondaryButton>
          )}
          <Button onClick={handleApply}>
            Apply Filters
          </Button>
        </ModalActions>
      </ModalContent>
    </ModalOverlay>
  );
};

export default FilterModal;
